export const adSignupConversion = () => {
  try {
    // 来自google ads
    gtag("event", "conversion", { send_to: "AW-11187366043/2gMmCMaGl7IYEJvRxtYp" });
  } catch (err) {}
  try {
    // bing 广告
    window.uetq = window.uetq || [];
    window.uetq.push("event", "signup", {});
  } catch (err) {}
  try {
    // Twitter广告
    window.twq("event", "tw-qos87-qpc7p", {});
  } catch (err) {}
  try {
    // Facebook 广告
    window.fbq("track", "CompleteRegistration");
  } catch (err) {}
};

export const adBuyConversion = (value: number) => {
  try {
    // 来自google ads
    gtag("event", "conversion", { send_to: "AW-11187366043/qq13CJD_vv8ZEJvRxtYp", value: value, currency: "USD" });
  } catch (err) {}
  try {
    // 来自百度广告
    window._agl && window._agl.push(["track", ["success", { t: 7 }]]);
  } catch (err) {}
  try {
    // bing 广告
    window.uetq = window.uetq || [];
    window.uetq.push("event", "click-purchase", {});
  } catch (err) {}
};

export const PurchaseSuccessKey = "purchase-success";
export const adPurchaseSuccessConversion = ({ value, currency }: { value: number; currency: string }) => {
  try {
    // 来自google ads
    gtag("event", "conversion", {
      send_to: "AW-11187366043/hP3TCI2h0P8ZEJvRxtYp",
      transaction_id: "",
      value: value,
      currency,
    });
  } catch (err) {}
  try {
    // 来自百度广告
    window._agl && window._agl.push(["track", ["success", { t: 3 }]]);
  } catch (err) {}
  try {
    // bing 广告
    window.uetq = window.uetq || [];
    window.uetq.push("event", PurchaseSuccessKey, {});
  } catch (err) {}
};

export const revertEmailPhoneMap: { [key in LOGIN_METHODS]: LOGIN_METHODS } = {
  email: "sms",
  email_password: "password",
  sms: "email",
  password: "email_password",
  wxcode: "wxcode",
};
